export enum ReceiptCouponRequestStatueType {
  DRAFT = 'DRAFT',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum ReceiptCouponType {
  DISCOUNT_COUPON = 'DISCOUNT_COUPON',
  FREE_AND_SPECIAL_PRICE_COUPON = 'FREE_AND_SPECIAL_PRICE_COUPON'
}

export enum ReceiptCouponModeEnum {
  REQUEST_CREATE = 'REQUEST_CREATE',
  REQUEST_VIEW = 'REQUEST_VIEW',
  REQUEST_EDIT = 'REQUEST_EDIT',
  VIEW = 'VIEW'
}

export enum RewardItemErrorEnum {
  INVALID_BARCODE = 'INVALID_BARCODE',
  INACTIVE_BARCODE = 'INACTIVE_BARCODE',
  RESTRICT_ITEM = 'RESTRICT_ITEM',
  NOT_ALLOW_FIX_ASSET = 'NOT_ALLOW_FIX_ASSET',
  NOT_ALLOW_STORE_USE = 'NOT_ALLOW_STORE_USE',
  NOT_ALLOW_ZERO = 'NOT_ALLOW_ZERO',
  DUPLICATED_BARCODE = 'DUPLICATED_BARCODE'
}
